import { createContext, useContext } from 'react'

import { Office } from '~/models/types'

import {
  drawerContent,
  DrawerContent,
  drawerPosition,
  DrawerPosition,
} from './types'

export type MapContextType = {
  isOpenDrawer: boolean
  isOpenInfoWindow: boolean
  clickedPin: Office | null
  currentDrawerPosition: DrawerPosition
  currentDrawerContent: DrawerContent
  prevDrawerContent: DrawerContent
}

export const MapContext = createContext<MapContextType>({
  isOpenDrawer: false,
  isOpenInfoWindow: false,
  clickedPin: null,
  currentDrawerPosition: drawerPosition.bottom,
  currentDrawerContent: drawerContent.list,
  prevDrawerContent: drawerContent.list,
})

export const useMapContext = () => {
  const context = useContext(MapContext)
  if (!context) {
    throw new Error('useMapContext must be used within a MapProvider')
  }
  return context
}

type MapDispatchContextType = {
  openDrawer: () => void
  closeDrawer: () => void
  openSearchForm: () => void
  closeSearchForm: () => void
  openInfoWindow: (office: Office) => void
  closeInfoWindow: () => void
  setDrawerPosition: (drawerPosition: DrawerPosition) => void
  setDrawerContent: (drawerContent: DrawerContent) => void
  onClickOfficeCard: (office: Office) => void
  onClickGoToList: () => void
}

export const MapDispatchContext = createContext<MapDispatchContextType>({
  openDrawer: () => {},
  closeDrawer: () => {},
  openSearchForm: () => {},
  closeSearchForm: () => {},
  openInfoWindow: () => {},
  closeInfoWindow: () => {},
  setDrawerPosition: () => {},
  setDrawerContent: () => {},
  onClickOfficeCard: () => {},
  onClickGoToList: () => {},
})

export const useMapDispatchContext = () => {
  const context = useContext(MapDispatchContext)
  if (!context) {
    throw new Error('useMapDispatchContext must be used within a MapProvider')
  }
  return context
}
